import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import Input from 'components/common/form/input/Input';
import { Formik, Form } from 'formik';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { ForgotPasswordProp } from './forgotPasswordForm.type';
import { useForgotPasswordMutation } from 'service/authQuery/authQuery';
import { useToast } from 'hooks/useToast';

const ForgotPasswordForm = () => {
  const [sendMailPassword, { isLoading }] = useForgotPasswordMutation();
  const { open } = useToast();
  const handleSubmit = (payload: ForgotPasswordProp) => {
    sendMailPassword(payload)
      .unwrap()
      .then(res => open(res?.data, 'success'))
      .catch(err => open(err?.data?.error, 'error'));
  };
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Forgot Password</h3>
        <p className="text-body-tertiary">Enter email for reset link.</p>
      </div>
      <div className="position-relative">
        <hr className="bg-body-secondary mt-5 mb-4" />
        <div className="divider-content-center">Reset password with email</div>
      </div>
      <Formik
        initialValues={{
          email: ''
        }}
        validationSchema={Yup.object({
          email: Yup.string()
            .email('Invalid email address')
            .required('Email is required')
        })}
        onSubmit={handleSubmit}
      >
        <Form>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="email">Email address</FormLabel>
            <div className="form-icon-container">
              <Input
                name="email"
                id="email"
                type="email"
                className="form-icon-input"
                icon={
                  <FontAwesomeIcon
                    icon={faUser}
                    className="text-body fs-9 form-icon"
                  />
                }
              />
            </div>
          </FormGroup>
          <Button
            variant="primary"
            type="submit"
            className="w-100 mb-3"
            loading={isLoading}
            loadingPosition="start"
          >
            Send Reset Link
          </Button>
        </Form>
      </Formik>
      <div className="text-center mt-4">
        <Link to="/sign-in" className="fs-9 fw-semibold">
          Back to Sign In
        </Link>
      </div>
    </>
  );
};

export default ForgotPasswordForm;
